import { type FC, useMemo } from 'react';

import AssignCollaboratorsToAttachmentForm from '@/components/AssignCollaboratorsToAttachmentForm';
import { type WorkflowCollaborator } from '@/hooks/useUserWorkflowContext';
import { type WorkflowOwner } from '@/tsClient/servers/noodleApi/ApiDefinition/workflows';
import { type MESSAGE_ATTACHMENT_REFERENCE_TYPES } from '@/typings/api-models';

import s from './ESignatureModal.module.scss';

type Props = {
  attachmentReferenceId: string;
  attachmentType: MESSAGE_ATTACHMENT_REFERENCE_TYPES;
  collaborators: WorkflowCollaborator[];
  handleCollaboratorAssignment: (owners: WorkflowOwner[]) => void;
  isSubmitting: boolean;
};

const ESignatureCollaboratorsSelection: FC<Props> = ({
  attachmentReferenceId,
  attachmentType,
  collaborators,
  handleCollaboratorAssignment,
  isSubmitting,
}) => {
  const segratedCollaborators: WorkflowCollaborator[] = useMemo(
    () =>
      collaborators.map((collaborator) =>
        collaborator.source === 'customer' ? { ...collaborator, defaultWorkflowRole: 'customer' } : collaborator,
      ),
    [collaborators],
  );

  return (
    <div className={s.collaboratorsSelection}>
      <AssignCollaboratorsToAttachmentForm
        attachmentReferenceId={attachmentReferenceId}
        attachmentType={attachmentType}
        collaborators={segratedCollaborators}
        onSubmit={handleCollaboratorAssignment}
        isSubmitting={isSubmitting}
        disableAssignCollaboratorsToModal={true}
      />
    </div>
  );
};

export default ESignatureCollaboratorsSelection;
